import { ROUTES, SECTION_IDS } from '../../../core/constants/navigation';
import { site } from '../../../global/config/site';
import Button from '../../../common/components/Button/Button';
import Reveal from '../../../common/components/Reveal/Reveal';
import { IconArrowRight, IconMail } from '../../../common/icons';

import '../styles/cta.css';

export default function Cta() {
    return (
        <section className="cta-band" aria-labelledby="cta-title">
            <div className="layout-container">
                <Reveal className="cta-band__panel">
                    <div className="cta-band__content">
                        <h2 id="cta-title" className="cta-band__title">¿Tienes un proyecto en mente?</h2>
                        <p className="cta-band__text">
                            Cuéntanos qué necesita tu medio y armamos juntos la mejor ruta para lograrlo.
                        </p>
                    </div>
                    <div className="cta-band__actions">
                        <Button to={{ pathname: ROUTES.HOME, hash: `#${SECTION_IDS.CONTACT}` }} icon={<IconArrowRight />}>
                            Cotizar proyecto
                        </Button>
                        <Button href={`mailto:${site.contactEmail}`} variant="ghost-inverted" icon={<IconMail />}>
                            Escríbenos
                        </Button>
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
